module.exports = __webpack_public_path__ + "static/media/logo.2879a9aa.png";